import { render } from "./subSummary.vue?vue&type=template&id=52d8489c"
import script from "./subSummary.vue?vue&type=script&lang=js"
export * from "./subSummary.vue?vue&type=script&lang=js"

import "./subSummary.vue?vue&type=style&index=0&id=52d8489c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__